module.exports = __webpack_public_path__ + "img/gaOngJwsRYRaVAuXXcmB.473a3c87.png";